import React from "react";
import { array, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

// import SubscribeMail from "../../../molecules/SubscribeMail";
import MobilePlayStore from "../../../molecules/MobilePlayStore";
import StaticFooterLinks from "../../../molecules/StaticFooterLinks";
import FooterMenuGroup from "../../../molecules/FooterMenuGroup";
import Instagram from "../KishoraloFooter/Instagram";
import { Facebook, Twitter } from "../../../atoms/icons/StoryPageIcons";
import Youtube from "./Youtube";
import DefaultFooterLogo from "./DefaultFooterLogo";

import { logoRenderer } from "../../../utils/react-utils";
import { getSocialLinks } from "../../../utils/utils";

import "./defaultFooter.m.css";

const DefaultFooterBase = ({
  publisherSettings,
  prothomaloMenuItems,
  pageType,
  publisherAttributes,
  socialLinks,
  currentPath
}) => {
  const menuItems = prothomaloMenuItems.find(item => item.title === "footer");
  const footerBottom = prothomaloMenuItems.find(item => item.title === "Footer Bottom");
  const footerBottomLinks = footerBottom && footerBottom.children.length > 0 ? footerBottom.children : null;
  const initialFooterBottomLinks =
    footerBottomLinks && footerBottomLinks.length > 1 ? footerBottomLinks.slice(0, footerBottomLinks.length - 1) : null;
  const lastFooterBottomLinks =
    footerBottomLinks && footerBottomLinks.length > 0 ? footerBottomLinks[footerBottomLinks.length - 1] : null;
  const socialLinksdata = getSocialLinks("prothomalo", socialLinks);

  return (
    <div styleName="footer">
      <div styleName={`row1 ${pageType === "home-page" ? "no-border" : ""}`}>
        <div styleName="logo">{logoRenderer(<DefaultFooterLogo />, currentPath)}</div>

        {menuItems && menuItems.children && menuItems.children.length > 0 ? (
          <div styleName="footer-links">
            <FooterMenuGroup links={menuItems.children.slice(0, 7)} language={publisherAttributes.lang} />
          </div>
        ) : null}
      </div>
      <div styleName="row2">
        <div styleName="social-links">
          {socialLinksdata.fbUrl && (
            <Link href={socialLinksdata.fbUrl} target="_blank" rel="noopener noreferrer">
              <Facebook color1="#eee" color2="#121212" />
            </Link>
          )}
          {socialLinksdata.twitterUrl && (
            <Link href={socialLinksdata.twitterUrl} target="_blank" rel="noopener noreferrer">
              <Twitter color1="#eee" color2="#121212" />
            </Link>
          )}
          {socialLinksdata.InstagramUrl && (
            <Link href={socialLinksdata.InstagramUrl} target="_blank" rel="noopener noreferrer">
              <Instagram color1="#eee" color2="#121212" />
            </Link>
          )}
          {socialLinksdata.YouTubeUrl && (
            <Link href={socialLinksdata.YouTubeUrl} className="youtube-icon" target="_blank" rel="noopener noreferrer">
              <Youtube />
            </Link>
          )}
        </div>
        <div styleName="app">
          <MobilePlayStore />
        </div>
      </div>
      <div styleName={`row3 ${publisherAttributes.lang === "en" ? "eng-row3" : ""}`}>
        <div styleName="copyright">{publisherSettings.copyright || ""}</div>
        <div styleName="static-links">
          {initialFooterBottomLinks && initialFooterBottomLinks.length ? (
            <StaticFooterLinks links={initialFooterBottomLinks} />
          ) : null}
        </div>
        {lastFooterBottomLinks && (
          <div styleName="default-editor">
            {lastFooterBottomLinks["item-type"] === "placeholder" ? (
              <span>{lastFooterBottomLinks.title}</span>
            ) : (
              <a href={lastFooterBottomLinks.completeUrl}>{lastFooterBottomLinks.title}</a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    staticFooterLinks: get(state, ["qt", "data", "navigationMenu", "staticFooterLinks"], []),
    publisherSettings: get(state, ["qt", "config", "publisher-settings"], {}),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
    prothomaloMenuItems: get(state, ["qt", "data", "navigationMenu", "prothomaloMenuItems"], []),
    pageType: get(state, ["qt", "pageType"], ""),
    socialLinks: get(state, ["qt", "config", "social-links"], {}),
    currentPath: get(state, ["currentPathReducer", "currentPath"], null)
  };
}

DefaultFooterBase.propTypes = {
  staticFooterLinks: array,
  publisherSettings: object,
  prothomaloMenuItems: array,
  pageType: string,
  publisherAttributes: object,
  socialLinks: object,
  currentPath: string
};

export const DefaultFooter = connect(mapStateToProps)(DefaultFooterBase);
